import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import avatar from "../../assets/images/blogs/avatar.png";
import { attachmentSvg, idCardSvg} from "../../utils/icons";
//import FormValidation from "../form/FormValidation";
//import HoverCard from "../ui/HoverCard";
//import Input from "../ui/Input";
import { Tag } from "../ui/Tag";
//import Toggle from "../ui/Toggle";
//import { Button } from "../ui/buttons/Button";
import RatingStars from "../ui/buttons/RatingStars";
//import Swal from "sweetalert2";
const JobPerson = ({ jobPerson }) => {
  const [project, setProject] = useState(null);
  const { key_jobs } = useParams();

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await fetch(`https://eprof-production-6g7zxvibga-uc.a.run.app/api/v1/JobList/`);
        if (!response.ok) {
          throw new Error("Error al obtener los datos del proyecto");
        }
        const projectData = await response.json();
        const filteredProject = projectData.find(project => project.key_jobs === key_jobs);
        if (filteredProject) {
          setProject(filteredProject);
        } else {
          throw new Error("No se encontró el proyecto con la clave proporcionada");
        }
      } catch (error) {
        console.error("Error al obtener los datos del proyecto:", error);
      }
    };

    if (key_jobs) {
      fetchProject();
    } else {
      console.error("No se encontró 'key_jobs' en la URL.");
    }
  }, [key_jobs]);

  if (!project) {
    return <p>Cargando...</p>;
  }

  return (
    <div className="flex flex-col justify-start items-start w-full max-w-[321px] gap-[30px] p-[30px] bg-white border border-[#cdcdcd]     h-fit">
      <div className="relative flex flex-col items-start  justify-start gap-4">
        <p className=" w-full max-w-[261px] h-[22px] text-base font-bold text-left text-[#373737]">
          Acerca del cliente
        </p>
        <div className="flex justify-start items-center   relative gap-2.5">
          <div className="  w-10 h-10 relative overflow-hidden rounded-[30.56px]">
            <img
              src={jobPerson.avatar ?? avatar}
              alt="rectangle-1413.png"
              className="w-10 h-10 absolute left-[-0.44px] top-[-0.44px] object-cover"
            />
          </div>
          <div className="flex flex-col justify-center items-start   gap-[5px]">
            <div className="flex justify-start items-center   relative gap-[5px]">
              <p className="  text-base font-bold text-left text-[#373737]">
                {project.name}
              </p>
              <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="relative w-6 h-6"
                preserveAspectRatio="none"
              >
                <path d="M21.9997 5H2V18.3333H21.9997V5Z" fill="white" />
                <path d="M8.66643 5H2V18.3333H8.66643V5Z" fill="#4997D0" />
                <path d="M22.0004 5H15.334V18.3333H22.0004V5Z" fill="#4997D0" />
              </svg>
            </div>
          </div>
        </div>
        <div className="flex justify-start items-center    relative gap-[5px]">
          <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative w-5 h-5"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M10 3.33301C7.21354 3.33301 5 5.59863 5 8.33301C5 10.208 5.59896 10.7809 8.93229 16.0934C9.42708 16.8747 10.5469 16.8747 11.0417 16.0934C14.375 10.7809 15 10.208 15 8.33301C15 5.57259 12.7344 3.33301 10 3.33301ZM10 15.4163C6.66667 10.1038 6.25 9.7653 6.25 8.33301C6.25 6.27572 7.91667 4.58301 10 4.58301C12.0573 4.58301 13.75 6.27572 13.75 8.33301C13.75 9.7653 13.3333 10.0518 10 15.4163ZM7.91667 8.33301C7.91667 9.50488 8.82812 10.4163 10 10.4163C11.1458 10.4163 12.0833 9.50488 12.0833 8.33301C12.0833 7.18717 11.1458 6.24967 10 6.24967C8.82812 6.24967 7.91667 7.18717 7.91667 8.33301Z"
              fill="#292929"
            />
          </svg>
          <p className="w-full max-w-[236px] text-sm text-left text-[#373737]">
            {project.district || "No district provided"}
            {project.department && `, ${project.department}`}
          </p>
        </div>
        <div className="flex justify-start items-center    relative gap-[5px]">
          <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative w-5 h-5"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M9.99935 3.54199C6.43164 3.54199 3.54102 6.43262 3.54102 10.0003C3.54102 13.568 6.43164 16.4587 9.99935 16.4587C13.5671 16.4587 16.4577 13.568 16.4577 10.0003C16.4577 6.43262 13.5671 3.54199 9.99935 3.54199ZM9.99935 15.2087C7.10872 15.2087 4.79102 12.891 4.79102 10.0003C4.79102 7.13574 7.10872 4.79199 9.99935 4.79199C12.8639 4.79199 15.2077 7.13574 15.2077 10.0003C15.2077 12.891 12.8639 15.2087 9.99935 15.2087ZM11.5879 12.5003C11.7441 12.6045 11.9264 12.5785 12.0306 12.4222L12.5254 11.7712C12.6296 11.6149 12.6035 11.4326 12.4473 11.3285L10.7285 10.0524V6.35449C10.7285 6.19824 10.5723 6.04199 10.416 6.04199H9.58268C9.40039 6.04199 9.27018 6.19824 9.27018 6.35449V10.6514C9.27018 10.7295 9.29622 10.8337 9.37435 10.8857L11.5879 12.5003Z"
              fill="#292929"
            />
          </svg>
          <p className=" w-full max-w-[236px] text-sm text-left text-[#373737]">
            Miembro desde 1 mar 2020
          </p>
        </div>
        <div className="relative flex items-center justify-start gap-4">
          <RatingStars rating={3.5} />
          <p className="  text-base text-left text-[#373737]">3,5</p>
        </div>
      </div>
      <div className="relative flex flex-col items-start  justify-start gap-4">
        <p className=" w-full max-w-[261px] h-[22px] text-base font-bold text-left text-[#373737]">
          Verificación del cliente
        </p>
        <div className="flex justify-start items-center    relative gap-[5px]">
          <img src={idCardSvg} alt="idCardSvg" />
          {/* <div className="relative w-5 h-5 overflow-hidden">
<p className="absolute left-[0.5px] top-[1.33px] text-base text-center text-[#00bc4f]">
    id-card
</p>
</div> */}
          <p className=" w-full max-w-[236px] text-sm text-left text-[#373737]">
            Identidad verificada
          </p>
        </div>
        <div className="flex justify-start items-center    relative gap-[5px]">
          <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative w-5 h-5"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M16.849 11.458C16.0417 10.7809 15.0521 11.0413 14.5573 11.432L12.9948 12.6038H12.8906C12.8906 11.6143 12.1094 10.833 11.0938 10.833H7.34375C6.61458 10.833 5.88542 11.0934 5.3125 11.5361L4.55729 12.083H2.91667C2.68229 12.083 2.5 12.2913 2.5 12.4997V12.9163C2.5 13.1507 2.68229 13.333 2.91667 13.333H5L6.06771 12.5257C6.43229 12.2393 6.875 12.083 7.34375 12.083H11.0938C11.8229 12.083 11.849 13.1507 11.0677 13.1507H9.50521C9.32292 13.1507 9.16667 13.307 9.16667 13.4893V13.5153C9.16667 13.6976 9.32292 13.8538 9.50521 13.8538H13.0208C13.2813 13.8538 13.5156 13.7757 13.724 13.6195L15.3125 12.4215C15.5208 12.2653 15.8594 12.2653 16.0417 12.4215C16.3281 12.6559 16.3021 13.0205 16.0417 13.2288L13.4115 15.182C13.2031 15.3382 12.9688 15.4163 12.7083 15.4163H2.91667C2.68229 15.4163 2.5 15.6247 2.5 15.833V16.2497C2.5 16.484 2.68229 16.6663 2.91667 16.6663H12.7083C13.2292 16.6663 13.75 16.5101 14.1667 16.1976L16.7708 14.2184C17.2135 13.9059 17.474 13.4111 17.474 12.8643C17.5 12.3434 17.2656 11.8226 16.849 11.458ZM9.19271 7.10905L10.4948 7.47363C10.599 7.49967 10.651 7.5778 10.651 7.68197C10.651 7.81217 10.5729 7.91634 10.4427 7.91634H9.58333C9.50521 7.91634 9.40104 7.8903 9.32292 7.83822C9.19271 7.78613 9.03646 7.81217 8.95833 7.8903L8.48958 8.35905C8.35938 8.48926 8.38542 8.72363 8.54167 8.8278C8.77604 9.01009 9.0625 9.08822 9.375 9.1403V9.58301C9.375 9.81738 9.55729 9.99967 9.79167 9.99967H10.2083C10.4167 9.99967 10.625 9.81738 10.625 9.58301V9.1403C11.4062 9.03613 12.0052 8.33301 11.901 7.49967C11.8229 6.90072 11.3542 6.43197 10.7812 6.24967L9.47917 5.88509C9.375 5.85905 9.32292 5.75488 9.32292 5.67676C9.32292 5.54655 9.42708 5.44238 9.53125 5.44238H10.3906C10.4948 5.44238 10.5729 5.46842 10.651 5.52051C10.7812 5.57259 10.9375 5.54655 11.0156 5.46842L11.4844 4.99967C11.6146 4.86947 11.6146 4.63509 11.4323 4.53092C11.1979 4.34863 10.9115 4.27051 10.625 4.21842V3.74967C10.625 3.54134 10.4167 3.33301 10.2083 3.33301H9.79167C9.55729 3.33301 9.375 3.54134 9.375 3.74967V4.21842C8.56771 4.32259 7.96875 5.02572 8.07292 5.85905C8.15104 6.45801 8.61979 6.92676 9.19271 7.10905Z"
              fill="#333333"
            />
          </svg>
          <p className=" w-full max-w-[236px] text-sm text-left text-[#373737]">
            Pago verificado
          </p>
        </div>
        <div className="flex justify-start items-center    relative gap-[5px]">
          <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative w-5 h-5"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M16.224 4.16699H3.75C3.04688 4.16699 2.5 4.73991 2.5 5.41699V14.5837C2.5 15.2868 3.04688 15.8337 3.75 15.8337H16.224C16.9271 15.8337 17.5 15.2868 17.5 14.5837V5.41699C17.5 4.73991 16.9271 4.16699 16.224 4.16699ZM3.90625 5.41699H16.0677C16.1719 5.41699 16.224 5.49512 16.224 5.57324V6.66699H3.75V5.57324C3.75 5.49512 3.80208 5.41699 3.90625 5.41699ZM16.0677 14.5837H3.90625C3.80208 14.5837 3.75 14.5316 3.75 14.4274V10.0003H16.224V14.4274C16.224 14.5316 16.1719 14.5837 16.0677 14.5837ZM7.5 11.9795C7.5 11.8232 7.34375 11.667 7.1875 11.667H5.3125C5.13021 11.667 5 11.8232 5 11.9795V13.0212C5 13.2035 5.13021 13.3337 5.3125 13.3337H7.1875C7.34375 13.3337 7.5 13.2035 7.5 13.0212V11.9795ZM12.5 11.9795C12.5 11.8232 12.3438 11.667 12.1875 11.667H8.64583C8.46354 11.667 8.33333 11.8232 8.33333 11.9795V13.0212C8.33333 13.2035 8.46354 13.3337 8.64583 13.3337H12.1875C12.3438 13.3337 12.5 13.2035 12.5 13.0212V11.9795Z"
              fill="#00BC4F"
            />
          </svg>
          <p className=" w-full max-w-[236px] text-sm text-left text-[#373737]">
            Depósito realizado
          </p>
        </div>
        <div className="flex justify-start items-center    relative gap-[5px]">
          <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative w-5 h-5"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M16.5 4H3.5C2.65625 4 2 4.6875 2 5.5V14.5C2 15.3438 2.65625 16 3.5 16H16.5C17.3125 16 18 15.3438 18 14.5V5.5C18 4.6875 17.3125 4 16.5 4ZM16.5 5.5V6.78125C15.7812 7.375 14.6562 8.25 12.2812 10.125C11.75 10.5312 10.7188 11.5312 10 11.5C9.25 11.5312 8.21875 10.5312 7.6875 10.125C5.3125 8.25 4.1875 7.375 3.5 6.78125V5.5H16.5ZM3.5 14.5V8.71875C4.1875 9.28125 5.21875 10.0938 6.75 11.3125C7.4375 11.8438 8.65625 13.0312 10 13C11.3125 13.0312 12.5 11.8438 13.2188 11.3125C14.75 10.0938 15.7812 9.28125 16.5 8.71875V14.5H3.5Z"
              fill="#333333"
            />
          </svg>
          <p className=" w-full max-w-[236px] text-sm text-left text-[#373737]">
            Email verificado
          </p>
        </div>
        <div className="flex justify-start items-center    relative gap-[5px]">
          <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative w-5 h-5"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M12.3171 11.2497C11.5618 11.2497 11.2233 11.6663 9.99935 11.6663C8.74935 11.6663 8.41081 11.2497 7.6556 11.2497C5.72852 11.2497 4.16602 12.8382 4.16602 14.7653V15.4163C4.16602 16.1195 4.71289 16.6663 5.41602 16.6663H14.5827C15.2598 16.6663 15.8327 16.1195 15.8327 15.4163V14.7653C15.8327 12.8382 14.2441 11.2497 12.3171 11.2497ZM14.5827 15.4163H5.41602V14.7653C5.41602 13.5153 6.4056 12.4997 7.6556 12.4997C8.04622 12.4997 8.64518 12.9163 9.99935 12.9163C11.3275 12.9163 11.9264 12.4997 12.3171 12.4997C13.5671 12.4997 14.5827 13.5153 14.5827 14.7653V15.4163ZM9.99935 10.833C12.0566 10.833 13.7493 9.16634 13.7493 7.08301C13.7493 5.02572 12.0566 3.33301 9.99935 3.33301C7.91602 3.33301 6.24935 5.02572 6.24935 7.08301C6.24935 9.16634 7.91602 10.833 9.99935 10.833ZM9.99935 4.58301C11.3535 4.58301 12.4993 5.72884 12.4993 7.08301C12.4993 8.46322 11.3535 9.58301 9.99935 9.58301C8.61914 9.58301 7.49935 8.46322 7.49935 7.08301C7.49935 5.72884 8.61914 4.58301 9.99935 4.58301Z"
              fill="#00BC4F"
            />
          </svg>
          <p className=" w-full max-w-[236px] text-sm text-left text-[#373737]">
            Perfil completado
          </p>
        </div>
        <div className="flex justify-start items-center    relative gap-[5px]">
          <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative w-5 h-5"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M15.9382 11.9268L13.2819 10.807C13.1517 10.7549 12.9954 10.7028 12.8132 10.7028C12.4486 10.7028 12.11 10.8851 11.9017 11.1455L11.0423 12.1872C9.66211 11.432 8.56836 10.3382 7.81315 8.95801L8.85482 8.09863C9.11523 7.8903 9.29753 7.55176 9.29753 7.18717C9.29753 7.00488 9.24544 6.84863 9.19336 6.71842L8.07357 4.06217C7.89128 3.64551 7.44857 3.33301 6.95378 3.33301C6.87565 3.33301 6.79753 3.35905 6.69336 3.38509L4.24544 3.93197C3.72461 4.06217 3.33398 4.53092 3.33398 5.10384C3.33398 11.5101 8.51628 16.6924 14.8965 16.6663C15.4694 16.6663 15.9382 16.2757 16.0684 15.7549L16.6152 13.307C16.6413 13.2028 16.6673 13.1247 16.6673 13.0465C16.6673 12.5518 16.3548 12.109 15.9382 11.9268ZM14.8444 15.4424C9.19336 15.4163 4.61003 10.807 4.58398 5.15592L6.92773 4.60905L8.02148 7.16113L6.25065 8.61947C7.47461 11.1976 8.80273 12.5257 11.3809 13.7497L12.8392 11.9788L15.3913 13.0726L14.8444 15.4424Z"
              fill="#00BC4F"
            />
          </svg>
          <p className=" w-full max-w-[236px] text-sm text-left text-[#373737]">
            Teléfono verificado
          </p>
        </div>
      </div>
    </div>
  );
};



export const JobContent = ({ data }) => {
  const [project, setProject] = useState(null);
  const { key_jobs } = useParams(); // Obtén key_jobs de los parámetros de la URL

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await fetch(`https://eprof-production-6g7zxvibga-uc.a.run.app/api/v1/JobList/`);
        if (!response.ok) {
          throw new Error("Error al obtener los datos del proyecto");
        }
        const projectData = await response.json();
        // Filtrar el proyecto por key_jobs
        const filteredProject = projectData.find(project => project.key_jobs === key_jobs);
        if (filteredProject) {
          setProject(filteredProject);
        } else {
          throw new Error("No se encontró el proyecto con la clave proporcionada");
        }
      } catch (error) {
        console.error("Error al obtener los datos del proyecto:", error);
      }
    };

    if (key_jobs) {
      fetchProject();
    } else {
      console.error("No se encontró 'key_jobs' en la URL.");
    }
  }, [key_jobs]);

  if (!project) {
    return <p>Cargando...</p>;
  }
  const { budgetRange, tags, attatchments, offerEndsIn } = data;
  return (
    <div className="flex flex-col justify-start items-start   w-full  gap-[30px] p-[30px] bg-white border border-[#cdcdcd]">
      <div className="relative flex flex-col items-start w-full  justify-start gap-4 ">
        <div className="w-full flex flex-col items-start  justify-between gap-4 lg:flex-row ">
          <p className=" w-full h-[29px] lg:text-lg text-xl font-bold text-left text-[#373737] ">
            Datos del trabajo
          </p>
          <div className="flex justify-start items-start shrink-0 gap-2.5 pb-1 border-t-0 border-r-0 border-b-2 border-l-0 border-[#d80027] ">
            <p className="  text-base text-left text-[#373737]">
              Presupuesto GTQ {budgetRange}
            </p>
          </div>
        </div>
        <div className="flex justify-start items-center    relative gap-[5px]">
          <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative w-5 h-5"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M9.99935 3.54199C6.43164 3.54199 3.54102 6.43262 3.54102 10.0003C3.54102 13.568 6.43164 16.4587 9.99935 16.4587C13.5671 16.4587 16.4577 13.568 16.4577 10.0003C16.4577 6.43262 13.5671 3.54199 9.99935 3.54199ZM9.99935 15.2087C7.10872 15.2087 4.79102 12.891 4.79102 10.0003C4.79102 7.13574 7.10872 4.79199 9.99935 4.79199C12.8639 4.79199 15.2077 7.13574 15.2077 10.0003C15.2077 12.891 12.8639 15.2087 9.99935 15.2087ZM11.5879 12.5003C11.7441 12.6045 11.9264 12.5785 12.0306 12.4222L12.5254 11.7712C12.6296 11.6149 12.6035 11.4326 12.4473 11.3285L10.7285 10.0524V6.35449C10.7285 6.19824 10.5723 6.04199 10.416 6.04199H9.58268C9.40039 6.04199 9.27018 6.19824 9.27018 6.35449V10.6514C9.27018 10.7295 9.29622 10.8337 9.37435 10.8857L11.5879 12.5003Z"
              fill="#333333"
            />
          </svg>
          <p className="  text-[10px] text-left text-[#373737]">
            LA PRESENTACIÓN DE OFERTAS TERMINA EN {offerEndsIn}
          </p>
        </div>
        <p className="   w-full  text-base text-left text-[#7b7b7b]">
          {project.description}
        </p>
      </div>
      <div className="relative flex flex-col items-start  justify-start gap-4">
        <p className="   w-full max-w-[756px] text-base font-bold text-left text-[#373737]">
          Habilidades necesarias
        </p>

        {/* lg:overflow-x-hidden */}
        <div className="flex justify-start items-start  gap-5 overflow-x-auto w-full max-w-[250px] min-h-[50px]">
          {tags.map((tag, id) => (
            <Tag hasClose={false} text={tag} key={id} />
          ))}
        </div>
      </div>
      {attatchments?.length ? (
        <div className="relative flex flex-col items-start  justify-start gap-4">
          <p className="   w-full max-w-[756px] text-base font-bold text-left text-[#373737]">
            Archivos adjuntos
          </p>
          <div className="flex items-start justify-start gap-4">
            {attatchments.map((attachment, id) => (
              <div
                key={`attach_${id}_${attachment.name}`}
                className="flex justify-start items-center   relative gap-[5px]"
              >
                <div className="relative overflow-hidden">
                  <img src={attachmentSvg} alt="attachmentSvg" />
                </div>
                <p className="hover:underline cursor-pointer   text-base text-left text-[#373737]">
                  {attachment.name}
                </p>
              </div>
            ))}
          </div>
          <div className="flex flex-col justify-center items-end    gap-2.5">
          </div>
        </div>
      ) : null}
    </div>
  );
};

const JobDetailSectionUnregistred = (props) => {
  const { data } = props;
  return (
    <div className="flex flex-col gap-5 lg:flex-row">
      <div className="flex flex-col items-start justify-start ">
        <JobContent data={data} />
      </div>

      <JobPerson jobPerson={data.jobPerson} />
    </div>
  );
};

export default JobDetailSectionUnregistred;
